import api from 'ApiConfig';

const studentService = {
  // Awdiz lms
  createStudent: async (data) => {
    console.log(data, 'sdjhd');
    // return api.post('/admin/create-student', data);
    return api.post('/admin/create-student', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  getstudentUploadedProfile: async (studentId) => {
    return api.post('/admin/get-student-profilepic', {
      studentId,
    });
  },
  verifyStudent: async (email, otp) => {
    return api.post('/admin/verify-student-otp', { email, otp });
  },
  updateStudent: async (payload) => {
    return api.post('/admin/update-student', payload);
  },
  makeReadyForPlacement: async (payload) => {
    return api.post('/admin/mark-student-placement-ready', payload);
  },
  swapBatch: async (payload) => {
    return api.post('/admin/swap-student-batch', payload);
  },
  correctEnrollment: async (payload) => {
    return api.post('/admin/correct-student-enrollment', payload);
  },

  getStudentOverview: async (batchId) => {
    return api.post('/admin/get-practicle-assignment-overview', { batchId });
  },
  getMcqTestOverview: async (batchId) => {
    return api.post('/admin/get-mcq-test-overview', { batchId });
  },
  getQaTestOverview: async (batchId) => {
    return api.post('/admin/get-qa-test-overview', { batchId });
  },
  //asignmnet
  getMCQAssignmentOverview: async (batchId) => {
    return api.post('/admin/get-mcq-assignment-overview', { batchId });
  },
  getQAAssignmentOverview: async (batchId) => {
    return api.post('/admin/get-qa-assignment-overview', { batchId });
  },
  //overview lms
  getStudentSwapHistory: async (payload) => {
    return api.post('/admin/get-student-swap-history', payload);
  },
  //Student
  uploadStudents: async (file, userId, classData) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('userId', userId);
    formData.append('classDetails', JSON.stringify(classData));

    return api.post('/admin/upload-students', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  getStudentsDetails: async (courseId, batchId, selectedBranch) => {
    return api.post('/admin/get-all-student', {
      courseId,
      batchId,
      selectedBranch,
    });
  },
  getSwapStudents: async (courseId, batchId, selectedBranch) => {
    return api.post('/admin/get-swap-student', {
      courseId,
      batchId,
      selectedBranch,
    });
  },
  getUnverifiedStudents: async (courseId, batchId, selectedBranch) => {
    return api.post('/admin/get-unverified-students', {
      selectedBranch,
    });
  },

  getParentDetails: async (orgId, parentId, studentId) => {
    return api.post('/admin/get-students-parent-details', {
      orgId,
      parentId,
      studentId,
    });
  },

  submitNewStudent: async (formData, userId) => {
    return api.post('/admin/new-student', {
      ...formData,
      userId,
    });
  },
  getStudentsByClass: async (userId, classId) => {
    return api.post('/admin/get-student-classwise', {
      userId,
      classId,
    });
  },

  //Upgrade Class

  upgradeStudentClass: async (
    orgId,
    currentYear,
    nextYear,
    currentClassId,
    nextClassId,
    notPassedStudents
  ) => {
    return api.post('/admin/upgrade-student-class', {
      orgId,
      currentYear,
      nextYear,
      currentClassId,
      nextClassId,
      notPassedStudents,
    });
  },
  upgradeSingleStudentClass: async (
    orgId,
    currentYear,
    nextYear,
    currentClassId,
    nextClassId,
    studentId
  ) => {
    return api.post('/admin/upgrade-single-student-class', {
      orgId,
      currentYear,
      nextYear,
      currentClassId,
      nextClassId,
      studentId,
    });
  },
  deactivateStudentAccount: async (studentId, orgId, reason) => {
    return api.post('/admin/deactive-student-account', {
      studentId,
      orgId,
      reason,
      accountType: 'Student',
    });
  },
  searchStudentsForPlacement: async (search, selectedBranch) => {
    return api.post('/admin/search-student-for-placement', {
      search,
      selectedBranch,
    });
  },
  getAllStudentforPlacement: async (courseId, batchId, selectedBranch) => {
    return api.post('/admin/get-all-student-for-placement', {
      courseId,
      batchId,
      selectedBranch,
    });
  },
  getStudentOverviewData: async (studentId) => {
    console.log(studentId, 'stujasnentId');
    return api.post('/admin/student-practicle-assignment-overview', {
      studentId,
    });
  },
  getMcqTestOverviewData: async (studentId) => {
    return api.post('/admin/student-get-mcq-test-overview', { studentId });
  },
  getQaTestOverviewData: async (studentId) => {
    return api.post('/admin/student-get-qa-test-overview', { studentId });
  },
  //asignmnet
  getMCQAssignmentOverviewData: async (studentId) => {
    return api.post('/admin/student-get-mcq-assignment-overview', {
      studentId,
    });
  },
  getQAAssignmentOverviewData: async (studentId) => {
    return api.post('/admin/student-get-qa-assignment-overview', { studentId });
  },
  studentPaymentDetails: async (studentId) => {
    return api.post('/admin/get-stuudent-payment-data', { studentId });
  },
  getUniqueSubjects: async (courseId, batchId) => {
    return api.get(`/admin/get-subject`, {
      params: { courseId, batchId },
    });
  },
  getUniqueDates: async (subjectName) => {
    return api.get(`/admin/get-mock-dates`, {
      params: { subjectName },
    });
  },
  getMockMarksByDate: async (courseId, batchId, testDate, subjectName) => {
    return api.post('/admin/get-existing-marks', {
      courseId,
      batchId,
      testDate,
      subjectName,
    });
  },
  getAllStudentDetailsData: async (courseId, batchId, selectedBranch) => {
    return api.post('/admin/get-all-student-detailed-data', {
      courseId,
      batchId,
      selectedBranch,
    });
  },
  getAllPausedStudents: async (courseId, batchId, selectedBranch) => {
    return api.post('/admin/get-all-paused-students', {
      courseId,
      batchId,
      selectedBranch,
    });
  },
  getStudentDetailsById: async (studentId) => {
    console.log(studentId, 'studentId');
    return api.post('/admin/get-student-by-id', { studentId });
  },
  getStudentPauseInfo: async (studentId) => {
    return api.post('/admin/get-student-pause-info', { studentId });
  },
  getAttendanceOverview: async (studentData) => {
    return api.post('/admin/get-student-attendance-overview', {
      studentId: studentData.studentId,
      course: studentData.course,
      batch: studentData.batch,
    });
  },

  getBatchAttendanceOverview: async (data) => {
    return api.post('/admin/get-batch-attendance-overview', data);
  },
  searchStudents: async (searchTerm, selectedBranch) => {
    return api.post('/admin/search-students', { searchTerm, selectedBranch });
  },
  getExternalMockResults: async (courseId, batchId, selectedBranch) => {
    return api.post('/admin/get-external-mock-results', {
      courseId, batchId, selectedBranch,
    });
  },
  getExternalMockOverview: async (batchId) => {
    return api.post('/admin/get-external-mock-overview', { batchId });
  },
  getExternalPracticeOverview: async (batchId) => {
    return api.post('/admin/get-external-practice-overview', { batchId });
  },
  getStudentExternalMockOverview: async (studentId) => {
    return api.post('/admin/student-external-mock-overview', { studentId });
  },
  getStudentExternalPracticeOverview: async (studentId) => {
    return api.post('/admin/student-external-practice-overview', { studentId });
  },
};
export default studentService;
